import { useContactsController } from './useContactsController';
import { ContactListControls } from './ContactListControls';
import { ContactListTable } from './ContactListTable';
import { ContactCreateDialog } from './ContactCreateDialog';
import { ContactEditImportDialogs } from './ContactEditImportDialogs';
export function ContactsPage() { const ctx = useContactsController(); return <div><ContactListControls ctx={ctx} /><ContactListTable ctx={ctx} /><ContactCreateDialog ctx={ctx} /><ContactEditImportDialogs ctx={ctx} /></div>; }
